// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__1Hqbo","title":"ClientReferral_title__2JiSv","itemText":"ClientReferral_itemText__3WRSp"};